import React from 'react';

export default function Footer() {
  return (
    <footer className="mt-20 bg-slate-950 text-slate-300">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-6 py-14">
        <div className="grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-fuchsia-500 to-indigo-600 grid place-items-center">
                <i className="ri-flashlight-line text-white text-xl"></i>
              </div>
              <span className="font-display text-2xl text-white">TRENDOVA</span>
            </div>
            <p className="text-sm text-slate-400 max-w-sm">India's fastest growing fashion destination. Curated styles, premium quality, lightning fast delivery.</p>
            <div className="flex gap-3 mt-5">
              <a className="w-9 h-9 grid place-items-center rounded-xl bg-white/10 hover:bg-white/20"><i className="ri-instagram-line"></i></a>
              <a className="w-9 h-9 grid place-items-center rounded-xl bg-white/10 hover:bg-white/20"><i className="ri-twitter-x-line"></i></a>
              <a className="w-9 h-9 grid place-items-center rounded-xl bg-white/10 hover:bg-white/20"><i className="ri-youtube-line"></i></a>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4">Shop</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="#" className="hover:text-white">Men</a></li>
              <li><a href="#" className="hover:text-white">Women</a></li>
              <li><a href="#" className="hover:text-white">Kids</a></li>
              <li><a href="#" className="hover:text-white">New Arrivals</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4">Help</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="#" className="hover:text-white">Track Order</a></li>
              <li><a href="#" className="hover:text-white">Returns</a></li>
              <li><a href="#" className="hover:text-white">Shipping</a></li>
              <li><a href="#" className="hover:text-white">FAQs</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4">Get App</h4>
            <div className="space-y-3">
              <a className="flex items-center gap-3 p-3 rounded-2xl bg-white/10 hover:bg-white/15">
                <i className="ri-apple-fill text-2xl"></i>
                <div className="text-xs leading-tight">Download on<br /><span className="text-sm font-semibold">App Store</span></div>
              </a>
              <a className="flex items-center gap-3 p-3 rounded-2xl bg-white/10 hover:bg-white/15">
                <i className="ri-google-play-fill text-2xl"></i>
                <div className="text-xs leading-tight">Get it on<br /><span className="text-sm font-semibold">Google Play</span></div>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© 2025 Trendova Pvt Ltd. All rights reserved.</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-slate-300">Privacy</a>
            <a href="#" className="hover:text-slate-300">Terms</a>
            <a href="#" className="hover:text-slate-300">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}